/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetActiveTypesByBboxRequest,
  TGetActiveTypesByBboxModel,
  IMappers,
  TGetActiveTypesByBboxResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IInfrastructureTypeResponse } from '../../entities/infrastructure/InfrastructureTypeResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetActiveTypesByBboxModel(parameters: IGetActiveTypesByBboxRequest): TGetActiveTypesByBboxModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'infrastructure-caching',
    pathApi: '/v1/get-active-types-by-bbox/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetActiveTypesByBboxOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetActiveTypesByBboxRequest;
}

export async function fetchGetActiveTypesByBbox<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetActiveTypesByBboxOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetActiveTypesByBboxResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetActiveTypesByBboxModel(parameters),
    config,
  )) as FetchResponse<TGetActiveTypesByBboxResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IInfrastructureTypeResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetActiveTypesByBboxResponse>;
}
